import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRightSmallDisabled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.52432 4.19969L10.2444 7.00269H1.5V9.00269H10.2444L7.52432 11.8047L8.95726 13.1997L14 8.00269L8.95726 2.80469L7.52432 4.19969Z",
		fill: "black",
		fillOpacity: .38
	})]
});
const ForwardRef = forwardRef(SvgArrowRightSmallDisabled);
export { ForwardRef as ReactComponent };
